export const getGameCanvas = () => document.getElementById('game-canvas');

export const getGameCanvasContext = () => {
  const canvas = getGameCanvas();
  if (canvas) {
    return canvas.getContext('2d');
  }
  return null;
};

export const resizeGameCanvas = (width, height) => {
  const canvas = getGameCanvas();
  if (canvas) {
    canvas.width = width;
    canvas.height = height;
  }
};

export const getGameCanvasStandards = () => {
  const canvas = getGameCanvas();
  const ctx = getGameCanvasContext();
  if (canvas && ctx) {
    return {
      canvas: canvas,
      ctx: ctx,
    };
  }
  return null; // Or handle the case where canvas or context is not available
};

export const createImgDom = (src) => {
  const imgDom = document.createElement('img');
  imgDom.src = src;
  return imgDom;
};

export const interpolation = (a, b, ALPHA) => {
  //interpolation a->b
  return b * ALPHA + a * (1 - ALPHA);
};

export const checkFPS = () => {
  return new Promise((resolve) => {
    const times = [];
    let fps = 0;
    let count = 0;

    function refreshLoop() {
      count++;
      window.requestAnimationFrame(() => {
        const now = performance.now();
        while (times.length > 0 && times[0] <= now - 1000) {
          times.shift();
        }
        times.push(now);
        fps += times.length;
        count < 500
          ? setTimeout(() => {
              refreshLoop();
            }, 0)
          : resolve(fps / count);
      });
    }

    refreshLoop();
  });
};

export const canvasMouseCoordsFixer = (x, y) => {
  const { canvas } = getGameCanvasStandards();
  const zoom = document.getElementById('root').style.zoom ? document.getElementById('root').style.zoom : 1;

  const fixedX = ((x / canvas.offsetWidth) * canvas.width) / zoom;
  const fixedY = ((y / canvas.offsetHeight) * canvas.height) / zoom;

  return { x: fixedX, y: fixedY };
};

export const shrinkTextFontByArea = (text, spaceWidth, defaultFontSize, fontFamily = 'Arial', fontWeight = 100) => {
  const { ctx } = getGameCanvasStandards();
  ctx.font = `${fontWeight} ${defaultFontSize}px ${fontFamily}`;

  if (ctx.measureText(text).width > spaceWidth) {
    return shrinkTextFontByArea(text, spaceWidth, defaultFontSize - 1, fontFamily, fontWeight);
  }

  return defaultFontSize;
};
